// Authentic brand assets, bundled in /public/brand for production reliability.
export const LOGO_URL = "/brand/logo.png";
export const MONOGRAM_URL = "/brand/monogram.png";
export const FOUNDER_URL = "/brand/founder.jpg";
export const BOOK_WYTYM_URL = "/brand/book-wytym.jpg";
export const BOOK_WSM_URL = "/brand/book-wsm.jpg";
